// Toggle checkboxes site_ja and site_en disabled attribute when check/uncheck site_fair checkbox
// Replace input position_title with latest cfair main_title_en
function controlSitePlacement(check_box_selectors, position_title_selector, content) {
  document.querySelectorAll(check_box_selectors).forEach(function (check_box) {
    check_box.checked = false;
    check_box.disabled = !check_box.disabled;
  });
  document.querySelector(position_title_selector).value = content;
}

function toggle_hidden_label(label_id) {
  let label = document.getElementById(label_id);
  if(label.style.display === "none") {
    label.style.display = "";
  } else {
    label.style.display = "none";
  }
}

function set_language_level_disabled(language_field, language_level_id) {
  if(language_field.value === "0") {
    $(language_level_id).attr("disabled","disabled");
    $(language_level_id).val("0");
  } else {
    $(language_level_id).removeAttr("disabled");
  }
}

function toggle_display_salary(checkbox_field, item_on_id, item_off_id){
  let item_on = document.querySelector(item_on_id);
  let item_off = document.querySelector(item_off_id);
  if (checkbox_field === null){
    return;
  }
  if(item_on !== null) {
    toggle_display(item_on)
  }
  if(item_off !== null) {
    toggle_display(item_off)
  }
}

function toggle_display(element) {
  if (element.style.display === "none") {
    element.style.display = "";
  } else {
    element.style.display = "none";
  }
}

function splitSalaryByMonth(){
  var monthIsPublic = document.getElementById('js-monthly_salary_is_public');
  var itemMinYearSalary = document.getElementById('job_form_min_salary');
  var itemMaxYearSalary = document.getElementById('job_form_max_salary');
  var itemMinYearSalarySplit = document.getElementById('js-min_monthly_salary');
  var itemMaxYearSalarySplit = document.getElementById('js-max_monthly_salary');
  var itemMonthSalarySplitCount = document.getElementById('js-month_split_value');
  if(monthIsPublic.checked){
      if(itemMinYearSalary.value > 0){
        if(itemMinYearSalary.value == 1){
          itemMinYearSalarySplit.value = (itemMinYearSalary[2].value/itemMonthSalarySplitCount.value).toFixed(0);
        }
        else if(itemMinYearSalary.value == 2){
          itemMinYearSalarySplit.value = (itemMinYearSalary[itemMinYearSalary.length-2].value/itemMonthSalarySplitCount.value).toFixed(0);
        }
        else{
          itemMinYearSalarySplit.value = (itemMinYearSalary.value/itemMonthSalarySplitCount.value).toFixed(0);
        }
      }else{
        itemMinYearSalarySplit.value = gon.salary_auto_displayed;
      }
      if(itemMaxYearSalary.value > 0){
        if(itemMaxYearSalary.value == 1){
          itemMaxYearSalarySplit.value = (itemMaxYearSalary[2].value/itemMonthSalarySplitCount.value).toFixed(0);
        }
        else if(itemMaxYearSalary.value == 2){
          itemMaxYearSalarySplit.value = (itemMaxYearSalary[itemMaxYearSalary.length-2].value/itemMonthSalarySplitCount.value).toFixed(0);
        }
        else{
          itemMaxYearSalarySplit.value = (itemMaxYearSalary.value/itemMonthSalarySplitCount.value).toFixed(0);
        }
      }else{
        itemMaxYearSalarySplit.value = gon.salary_auto_displayed;
      }
    }else{
      itemMinYearSalarySplit.value = gon.salary_auto_displayed;
      itemMaxYearSalarySplit.value = gon.salary_auto_displayed;
    }
}

function resetMonthlySalary(){
  document.getElementById('js-min_monthly_salary').value = gon.salary_auto_displayed;
  document.getElementById('js-max_monthly_salary').value = gon.salary_auto_displayed;
}

function add_option_to_text_area(option_str, text_area_selector) {
  let textarea = document.querySelector(text_area_selector);
  if (textarea.value.match(/^\s*$/)) {
    textarea.value = option_str;
  } else {
    textarea.value = textarea.value + "\r\n" + option_str;
  }
  textarea.focus();
}

function remove_element_hidden_before_submit() {
  const form = document.querySelector('form');
  const hour_salary_input = document.getElementById('js_hour_salary_input');
  const hour_salary_select = document.getElementById('js_hour_salary_select');
  if (hour_salary_input.style.display !== 'none' && hour_salary_select.style.display === 'none') {
    hour_salary_select.remove();
  }
  form.submit();
}

function submitForm() {
  remove_element_hidden_before_submit();
}

function preview_menu_button_click(target, position){
  if (position == 'top') {
    $('.preview-menu-button-bottom').hide();
    $('.preview-menu-button-top').find('.btn').not(target).prop('disabled', true);
  } else if (position == 'bottom') {
    $('.preview-menu-button-top').hide();
    $('.preview-menu-button-bottom').find('.btn').not(target).prop('disabled', true);
  }
}

const selectTab = (event) => {
  event.preventDefault()
  $('.nav-tabs .nav-link').removeClass('active')
  $(event.target).addClass('active')
  const elementName = $(event.target).attr('href')
  $('.tab-content .tab-pane').removeClass('active')
  $(elementName).addClass('active')
}

function checkJobFormChanged() {
  $('form#new_job_form').on('input change', 'input, select, textarea', function() {
    $('input#form_changed').val(true)
  })
}

function isNumberKey(event) {
  let inputValue = event.target.value;
  let numericValue = inputValue.replace(/\D/g, '');

  event.target.value = numericValue;
}

export {
  controlSitePlacement, toggle_hidden_label, set_language_level_disabled,
  toggle_display_salary, splitSalaryByMonth, resetMonthlySalary,
  add_option_to_text_area, preview_menu_button_click, selectTab,
  checkJobFormChanged, submitForm, isNumberKey
}
